/** basic.registerRecord */
export default {
    register_platformPla: "Выберите платформу регистрации",
    register_allResult: "Все результаты регистрации",
    register_registerSucc: "Регистрация успешна",
    register_registerLose: "Регистрация не удалась",
}

